// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__26IUQ","itemTitle":"ClientEmergencyInfo_itemTitle__2zldW","itemText":"ClientEmergencyInfo_itemText__1OPBT"};